import script from "./LatestNewsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LatestNewsSection.vue?vue&type=script&setup=true&lang=js"

import "./LatestNewsSection.vue?vue&type=style&index=0&id=a141cdf6&lang=css"

const __exports__ = script;

export default __exports__